import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

export const Card: React.FC<CardProps> = ({ children, className = '', hover = false, onClick }) => {
  const baseClasses = 'bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-2xl shadow-sm transition-smooth'
  const hoverClasses = hover ? 'hover:shadow-lg hover:border-gray-300/50 cursor-pointer hover:bg-white/90' : ''

  return (
    <div className={`${baseClasses} ${hoverClasses} ${className}`} onClick={onClick}>
      {children}
    </div>
  )
}
